import React from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";

const PreviewActionComponent = ({
  itemId,
  lightBox,
  iconName,
  tooltipDisabled,
}) => {
  const { setLightBox } = useLightBox();
  const { getFilesData } = useMail();
  const handleClick = () => {
    setLightBox(getFilesData()[itemId].Type, itemId);
  };
  return !tooltipDisabled ? (
    <Tooltip
      id={"previewFileActionIcon"}
      tooltipTextKey="preview-file-icon-tooltip-text"
      top
    >
      <Icon
        name={iconName || "show-password"}
        onClick={handleClick}
        gray
        clickable
      />
    </Tooltip>
  ) : (
    <Icon
      name={iconName || "show-password"}
      onClick={handleClick}
      gray
      clickable
    />
  );
};

export default PreviewActionComponent;
